// CustomerServicePage.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/home/chatbot/Header';
import SupportChannels from '../../components/home/chatbot/SupportChannels';
import GlobalStyles from '../../components/home/chatbot/GlobalStyles';
import Footer from '../../components/footer/index';

const CustomerServicePage = () => {
  const [selectedSupport, setSelectedSupport] = useState('chat');
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      
      <GlobalStyles />
      
      <Header currentTime={currentTime} />
        
      <SupportChannels 
        selectedSupport={selectedSupport}
        setSelectedSupport={setSelectedSupport}
      />
      <Footer />
    </div>
  );
};

export default CustomerServicePage;